import { createClaimEnquiry } from "../../api/claim-enquiry";
import { useNavigation } from "../../../hooks/useNavigation";
import { useAppSettingsSnapshot } from "../../settings";
import { ClaimDetails } from "../../funnels/pre-eligibility/state/preEligibilityState";
import { sendWarningReport } from "../../../utils/reporting";
import useClaimEnquiryCreatedEvent from "../../../tracking/events/claim-enquiry/claimEnquiryCreated";
import ClaimEnquiry from "../../../model/claim-enquiry/ClaimEnquiry";
import { ClaimEnquiryRest } from "../../../api/model/ClaimEnquiryRest";
import { useBrandSnapshot } from "../branding";
import { ItineraryFlights } from "../types/intake-funnel";

export function useCreateClaimEnquiry() {
  const { goTo, replaceTo } = useNavigation();
  const { locale, currency } = useAppSettingsSnapshot();
  const trackClaimEnquiryCreated = useClaimEnquiryCreatedEvent();
  const brand = useBrandSnapshot();

  return {
    createClaimEnquiry: async ({
      claimDetails,
      itineraryFlights,
      experiment,
    }: {
      claimDetails: ClaimDetails;
      itineraryFlights: Readonly<ItineraryFlights>;
      experiment?: string;
    }) => {
      try {
        const rawClaimEnquiry = await createClaimEnquiry({
          locale,
          currency,
          itineraryFlights,
          claimDetails: {
            ...claimDetails,
            totalDelay: experiment === "future_flight" ? "never" : claimDetails.totalDelay,
          },
          brand,
          experiment,
        });

        const claimEnquiry = new ClaimEnquiry(ClaimEnquiryRest.fromJson(rawClaimEnquiry));
        trackClaimEnquiryCreated(claimEnquiry);

        if (rawClaimEnquiry.claim_valid) {
          goTo(`/claim_enquiries/${rawClaimEnquiry.uuid}`);
        } else {
          goTo(`/claims/verify/${rawClaimEnquiry.uuid}/email`);
        }

        return rawClaimEnquiry;
      } catch (e) {
        sendWarningReport("Error creating claim enquiry", e);
        replaceTo("/claims/processing-error");
      }
    },
  };
}
